// Elenco della modulistica scaricabile.
// I file PDF vanno in /app/frontend/public/modulistica/
export const MODULI = [
  {
    title: "Modulo di iscrizione",
    desc: "Da compilare e inviare per iscrivere la squadra al campionato.",
    file: "iscrizione.pdf",
  },
  {
    title: "Elenco giocatori squadra",
    desc: "Elenco dei giocatori tesserati che compongono la rosa della squadra.",
    file: "elenco-giocatori-squadra.pdf",
  },
  {
    title: "Formazione squadra – Ospitante",
    desc: "Foglio schieramento per il capitano della squadra che ospita la gara.",
    file: "formazione-squadra-ospitante.pdf",
  },
  {
    title: "Formazione squadra – Ospite",
    desc: "Foglio schieramento per il capitano della squadra ospite.",
    file: "formazione-squadra-ospite.pdf",
  },
];
